import { useTranslation } from "react-i18next";
import { Box, Button, Image, Typography } from "@orion/ui";
import { FC } from "react";

type Props = {
  operationCode?: string;
  title: string;
  subtitleOne: string;
  subtitleTwo?: string;
  support?: boolean;
  cancelProcedure?: boolean;
  btnPrimaryTitle?: string;
  btnSecondaryTitle?: string;
  btnPrimarySubmit?: () => void;
  btnSecondarySubmit?: () => void;
};

export const AuthFailureNotification: FC<Props> = ({
  operationCode,
  title,
  subtitleOne,
  subtitleTwo,
  support,
  cancelProcedure,
  btnPrimaryTitle,
  btnSecondaryTitle,
  btnPrimarySubmit,
  btnSecondarySubmit,
}: Props) => {
  const { t } = useTranslation();
  return (
    <Box
      data-landmark="1"
      flex
      column
      justifyCenter
      gap13
    >
      {operationCode && (
        <Typography textNeutral70 mb15 textAlign="right">
          {t("login.codeVerification.operationCode")}
          <b>{operationCode}</b>
        </Typography>
      )}
      <Box flex justifyCenter >
        <Image
          tabIndex={-1}
          aria-hidden
          alt="Image"
          height={80}
          placeholder="LSHny%kXTenhPqRlbwWB0gaKn3kW"
          src=".\src\_shared\assets\images\failure.png"
          width={80}
        />
      </Box>
      <Box flex column gap9>
        <Typography text2xl textAlign="center">
          {title}
        </Typography>
        <Typography textBase textAlign="center">
          {subtitleOne}
        </Typography>
        {subtitleTwo && (
          <Typography textBase textAlign="center">
            {subtitleTwo}
          </Typography>
        )}
        {support && (
          <Box
            flex
            alignItems="flex-start"
            textAlign="center"
            justifyCenter
            alignContent="center"
          >
            <Typography textNeutral70>
              {t("login.authFailure.support")}
              <Typography
                ml3
                textPrimary100
              >
                {t("login.contactSupport")}
              </Typography>
            </Typography>
          </Box>
        )}
      </Box>
      <Box flex column justifyBetween gap9>
        <Box flex justifyCenter gap9>
          {btnPrimaryTitle && btnPrimarySubmit && (
            <Button
              type="submit"
              minWidth={"36"}
              onPress={() => btnPrimarySubmit()}
            >
              {btnPrimaryTitle}
            </Button>
          )}
          {btnSecondaryTitle && btnSecondarySubmit && (
            <Button
              type="submit"
              minWidth={"36"}
              variant="outlinePrimary"
              onPress={() => btnSecondarySubmit()}
            >
              {btnSecondaryTitle}
            </Button>
          )}
        </Box>
        {cancelProcedure && (
          <Box flex alignItems="center" justifyCenter alignContent="center">
            <Typography mt8 textAlign="center" textBase textNeutral70>
              {t("login.authFailure.cancelProcedure")}
            </Typography>
            <Typography
              mt8
              ml3
              textBase
              style={{ textDecoration: "underline", cursor: "pointer" }}
            >
              {t("login.cancel")}
            </Typography>
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default AuthFailureNotification;
